import React from 'react';

import classNames from 'classnames';

import { formatPrice } from '@shared/helpers';

import cls from './CustomerInformationBlock.module.css';
import { useCustomerInformationBlock } from './useCustomerInformationBlock';
import {
    FinancialIndicatorsInfoElement,
    FinancialInfoType,
} from '../../../UI/FinancialIndicatorsInfoElement/FinancialIndicatorsInfoElement';

interface CustomerInformationBlockProps {
    classes?: string;
}

export const CustomerInformationBlock = ({ classes }: CustomerInformationBlockProps) => {
    const { financial_info, is_customer } = useCustomerInformationBlock();
    return (
        <div className={classNames(cls.CustomerInformationBlock, [classes])}>
            <FinancialIndicatorsInfoElement
                title={
                    is_customer
                        ? i18next.t(
                              'CustomerInformationBlock.return.FinancialIndicatorsInfoElement.title.toBePaid'
                          )
                        : i18next.t(
                              'CustomerInformationBlock.return.FinancialIndicatorsInfoElement.title.customerDebt'
                          )
                }
                // @ts-ignore
                value={formatPrice(Math.round(financial_info?.key_metrics?.customer_debt), {
                    withCurrency: true,
                    currencySign: financial_info?.currency?.sign,
                })}
                negativeNumber={false}
                positiveNumber={false}
                financialInfoType={FinancialInfoType.CUSTOMER_DEBT}
            />
        </div>
    );
};
